/**
 * Licent
 *
 * @author Robuust
 */

import { Controller } from '@hotwired/stimulus';

/**
 * File Controller.
 */
export default class extends Controller {
  static targets = ['label'];

  /**
   * Update the selected file label.
   */
  update(e) {
    const file = e.target.files[0];
    this.labelTarget.textContent = file ? file.name : e.params.label;
  }
}
